/*
 * @Description: 数据概览
 * @Author: DXV-RGWU-TUFH-RFCY-IEGMYY
 * @Date: 2022-07-14 09:50:19
 * @LastEditTime: 2023-06-20 13:51:35
 * @LastEditors: DXV-RGWU-TUFH-RFCY-IEGMYY
 */
import {
  get
} from '../index'
export default {
  // 平台总金额
  orderData (querys) {
    return get('massage/admin/AdminIndex/orderData', querys)
  },
  // 代理商销售数据
  agentOrderData (querys) {
    return get('massage/admin/AdminIndex/agentOrderData', querys)
  },
  // 技-师用户数据
  coachAndUserData (querys) {
    return get('massage/admin/AdminIndex/coachAndUserData', querys)
  },
  // 技-师销售数据
  coachSaleData (querys) {
    return get('massage/admin/AdminIndex/coachSaleData', querys)
  },
  // 城市数据
  cityData (querys) {
    return get('massage/admin/AdminIndex/cityData', querys)
  },
  // 今日订单数据
  indexData (querys) {
    return get('massage/admin/AdminIndex/indexData', querys)
  },
  // 用户数据
  userData (querys) {
    return get('massage/admin/AdminIndex/userData', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/data.js